import NavBar from '@components/common/navbar'
import FirstFold from '@components/national-coding-olympiad-2021/thank-you-page/first-fold'
import ResourceFold from '@components/national-coding-olympiad-2021/thank-you-page/resource-fold'
import Banner from '@components/national-coding-olympiad-2021/thank-you-page/banner'
import Footer from '@components/common/footer'
import { WATCH_VIDEOS_ON_THEMES } from '@lib/data/nco-thank-you-page'
import { NextSeo } from 'next-seo'
import { watchVideosOnThemes } from '@lib/seo'

const WatchVideosThemes = () => (
  <>
    <NextSeo {...watchVideosOnThemes} />
    <NavBar isSticky />
    <FirstFold
      title="Watch videos on themes"
      subHeading="Our how-to videos help you understand the themes so you can build amazing projects that win the Hackathon."
    />
    <div style={{ background: '#FBFBFB' }}>
      <ResourceFold
        resourceData={WATCH_VIDEOS_ON_THEMES}
        imagePath="/images/national-coding-olympiad/thank-you-page/watch-videos-on-themes/"
        ctaText="Watch video"
      />
    </div>
    <Banner />
    <Footer />
  </>
)

export default WatchVideosThemes
